import MerchantConfirmationVehicleModal from "components/shared/Modal/vehicleModals/merchantConfirmationVehicleModal";
import MerchantInspectionSuccessModal from "components/shared/Modal/vehicleModals/merchantInspectionVehicleSuccess";
import MerchantsVehicleTermsAndCondition from "components/shared/Modal/vehicleModals/merchantsVehicleTermsAndConditions";
import MerchantsVehicleDetailsModal from "components/shared/Modal/vehicleModals/merchantVehicleDetails";
import MerchantVehicleSuccess from "components/shared/Modal/vehicleModals/merchantVehicleSuccess";
import VehicleLoadingModal from "components/shared/Modal/vehicleModals/vehicleLoadingModal";
import VehicleLoanProgress from "components/shared/Modal/vehicleModals/vehicleLoanProgressBarModal";
import VehicleFinancePinModal from "components/shared/Modal/vehicleModals/vehiclePinModal";
import { useAppDispatch } from "customHooks/useAppDispatch";
import { useAppSelector } from "customHooks/useAppSelector";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  createVehicleInspection,
  createVehicleRequest,
  getVehicleInfo,
  vehicleMonthlyRepay,
} from "store/api/vehicle-finance";
import {
  getUserVehicleDetail,
  paymentCodeSlice,
} from "store/reducers/vehicle-finance-slice";
import { sanitizeOutput } from "utils/toast-sanitizer";

const VehiclePayment = () => {
  const [isModalOpenVerification, setIsModalOpenVerification] = useState(false);
  const [isModalOpenDirectorForm, setIsModalOpenDirectorForm] = useState(false);
  const [isModalOpenSpinnner, setIsModalSpinner] = useState(false);
  const [isModalOpenSuccess, setIsModalSuccess] = useState(false);
  const [isModalOpenFailure, setIsModalFailure] = useState(false);
  const [isModalOpenCarDetails, setIsModalOpenCarDetails] = useState(false);
  const [isModalOpenMerchantOTP, setIsModalOpenMerchantOTP] = useState(false);
  const [isModalOpenInspectionSuccess, setIsModalOpenInspectionSuccess] =
    useState(false);
  const [isModalOpenMerchantConfirmation, setModalOpenMerchantConfirmation] =
    useState(false);
  const [isModalOpenMerchantTerms, setIsModalOpenMerchantTerms] =
    useState(false);
  const [isModalOpenMerchantSuccess, setIsModalOpenMerchantSuccess] =
    useState(false);
  const [isModalOpenPin, setIsModalOpenPin] = useState(false);
  const [loading, setLoading] = useState(false);
  const [tenor, setTenor] = useState("");
  const [equity, setEquity] = useState("");
  const [pin, setPin] = useState("");
  const [isInspection, setIsInspection] = useState(false);
  const [savePaymentResponse, setSavePaymentResponse] = useState();

  const [isModalOpenProgress, setIsModalOpenProgress] = useState(false);
  const [isModalOpenLoading, setIsModalOpenLoading] = useState(false);

  const [repaymentResponseData, setRepaymentResponseData] = useState("");

  const { paymentCode } = useParams<{ paymentCode?: string }>();
  const PaymentCode = paymentCode;
  const dispatch = useAppDispatch();

  const vehicleData = useAppSelector(
    (state) => state?.vehicleFinance?.vehicleInfo
  );

  const navigate = useNavigate();
  const [equityValue, setEquityValue] = useState(
    vehicleData?.EquityContribution
  );

  const LoanAmount =
    Number(vehicleData?.Amount) -
    (equityValue !== undefined && equityValue !== null
      ? Number(equityValue)
      : Number(vehicleData?.EquityContribution));

  const [checkInspection, setCheckInspection] = useState(false);
  useEffect(() => {
    dispatch(paymentCodeSlice(PaymentCode));
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (PaymentCode) {
      setIsModalOpenLoading(true);
      dispatch(getUserVehicleDetail({ paymentCode: PaymentCode }))
        .unwrap()
        .then((data) => {
          setIsModalOpenLoading(false);
          if (data?.InspectionStatus === "Completed") {
            setIsModalOpenCarDetails(false);
            setModalOpenMerchantConfirmation(true);
          } else {
            setModalOpenMerchantConfirmation(false);
            setIsModalOpenCarDetails(true);
          }
        })
        .catch((err: any) => {
          toast.error(sanitizeOutput(err));
        })
        .finally(() => {
          setIsModalOpenLoading(false); // Ensures loading modal closes in case of error
        });
    }
  }, [dispatch, PaymentCode]);

  const handleEquityInputChange = async (event: any, formik: any) => {
    const { value } = event.target;
    setEquityValue(value);
    formik.handleChange(event); // Update Formik state
    if (value && (tenor || vehicleData?.Tenor)) {
      let payload = {
        Amount: Number(vehicleData?.Amount),
        Tenor: Number(tenor || vehicleData?.Tenor),
        EquityContribution: Number(value),
      };
      setLoading(true);
      try {
        const response = await vehicleMonthlyRepay(payload);
        setLoading(false);
        if (response?.Status === 200) {
          setRepaymentResponseData(response?.Data);
          // toast.error(sanitizeOutput(response.Message);
        } else {
          setLoading(false);
          toast.error(sanitizeOutput(response?.Message));
        }
      } catch (error: any) {
        setLoading(false);
        toast.error(sanitizeOutput(error?.response?.data?.Message || error?.message));
        return error.response;
      }
      setLoading(false);
    }
  };

  const handleinspectionCheckboxChange = (event: any) => {
    setCheckInspection(event.target.checked);
  };

  const handleTenorSelectChange = async (value: any) => {
    setTenor(value);
    let payload = {
      Amount: Number(vehicleData?.Amount),
      Tenor: Number(value),
      EquityContribution: Number(equityValue || vehicleData?.EquityContribution),
    };
    setLoading(true);
    try {
      const response = await vehicleMonthlyRepay(payload);
      setLoading(false);
      if (response?.Status === 200) {
        setRepaymentResponseData(response?.Data);
        // toast.error(sanitizeOutput(response.Message);
      } else {
        setLoading(false);
        toast.error(sanitizeOutput(response?.Message));
      }
    } catch (error: any) {
      setLoading(false);
      toast.error(sanitizeOutput(error?.response?.data?.Message || error?.message));
      return error?.response;
    }
  };

  const getMonthlyRepayment = async () => {
    let payload = {
      Amount: Number(vehicleData?.Amount),
      Tenor: vehicleData?.Tenor,
      EquityContribution: Number(vehicleData?.EquityContribution),
    };
    setLoading(true);
    try {
      const response = await vehicleMonthlyRepay(payload);
      setLoading(false);
      if (response?.Status === 200) {
        setRepaymentResponseData(response?.Data);
        // toast.error(sanitizeOutput(response.Message);
      } else {
        setLoading(false);
        toast.error(sanitizeOutput(response?.Message));
      }
    } catch (error: any) {
      setLoading(false);
      toast.error(sanitizeOutput(error?.response?.data?.Message || error?.message));
      return error?.response;
    }
    setLoading(false);
  };

  useEffect(() => {
    if (
      vehicleData &&
      Object.keys(vehicleData).length > 0 &&
      vehicleData?.Tenor > 0
    ) {
      getMonthlyRepayment();
    }
  }, [vehicleData]);

  const handleSavePayment = async (value: any) => {
    setEquity(value.EquityContribution);
    handleMerchantSavePayment(value);
  };

  const handleMerchantSavePayment = async (value: any) => {
    setEquity(value.EquityContribution);
    let payload = {
      PaymentCode: PaymentCode,
      LoanAmount: Number(LoanAmount),
      Tenor: Number(tenor || vehicleData?.Tenor),
      EquityContribution: Number(value.EquityContribution),
      OptInForInspection:
        vehicleData?.Meta?.CarDetails?.IsNew === false
          ? false
          : checkInspection,
      Pin: pin,
    };
    setLoading(true);
    try {
      const response = await createVehicleInspection(payload);
      setLoading(false);
      if (response?.Status === 200) {
        if (
          vehicleData?.Meta?.CarDetails?.IsNew === true &&
          checkInspection === false
        ) {
          setIsModalOpenCarDetails(false);
          if (PaymentCode) {
            setLoading(true);
            setIsModalOpenProgress(true);
            dispatch(getUserVehicleDetail({ paymentCode: PaymentCode }))
              .unwrap()
              .then(() => {
                setLoading(false);
                setIsModalOpenProgress(false);
                setModalOpenMerchantConfirmation(true);
                // toast.error(sanitizeOutput(response?.Message);
              })
              .catch((err: any) => {
                toast.error(sanitizeOutput(err));
                setLoading(false);
                setIsModalOpenProgress(false);
              });
          }
        } else if (
          vehicleData?.Meta?.CarDetails?.IsNew === false ||
          checkInspection === true
        ) {
          setIsModalOpenProgress(true);
          dispatch(getUserVehicleDetail({ paymentCode: PaymentCode }))
            .unwrap()
            .then(() => {
              setLoading(false);
              setIsModalOpenProgress(false);
              setSavePaymentResponse(response?.Data);
              setIsModalOpenCarDetails(false);
              setIsModalOpenInspectionSuccess(true); /// show go for inspection successs
              toast.error(sanitizeOutput(response?.Message));
            })
            .catch((err: any) => {
              toast.error(sanitizeOutput(err));
              setLoading(false);
              setIsModalOpenProgress(false);
            });
        }
      } else {
        setIsModalOpenCarDetails(true);
        toast.error(sanitizeOutput(response?.Message));
      }
    } catch (error: any) {
      setLoading(false);
      setIsModalOpenCarDetails(true);
      toast.error(sanitizeOutput(error?.response?.data?.Message || error?.message));
      return error?.response;
    }
  };

  const handlePinVerification = async (e: React.FormEvent) => {
    e.preventDefault();
    let payload = {
      PaymentCode: PaymentCode,
      LoanAmount: Number(LoanAmount),
      Tenor: Number(tenor || vehicleData?.Tenor),
      EquityContribution: Number(equity || vehicleData?.EquityContribution),
      PinOrToken: pin,
    };
    setIsModalOpenPin(false);
    setIsModalOpenProgress(true);
    try {
      const response = await createVehicleRequest(payload);
      setIsModalOpenProgress(false);
      if (response?.Status === 200) {
        setIsModalOpenMerchantSuccess(true);
      } else {
        setIsModalOpenPin(true);
        toast.error(sanitizeOutput(response?.Message));
      }
    } catch (error: any) {
      setIsModalOpenProgress(false);
      setIsModalOpenPin(true);
      toast.error(sanitizeOutput(error?.response?.data?.Message || error?.message));
      return error?.response;
    }
  };

  const handleOpenMerchantTerms = () => {
    setModalOpenMerchantConfirmation(false);
    setIsModalOpenMerchantTerms(true);
  };

  const handleGoBackToEquity = () => {
    if (vehicleData?.InspectionStatus === "Completed") {
      setModalOpenMerchantConfirmation(false);
      navigate(-1);
    } else {
      setModalOpenMerchantConfirmation(false);
      setIsModalOpenCarDetails(true);
    }
  };

  const handleGoBackToSummary = () => {
    setIsModalOpenMerchantTerms(false);
    setModalOpenMerchantConfirmation(true);
  };

  const handleMerchantSuccesss = async () => {
    setIsModalOpenMerchantTerms(false);
    setIsModalOpenPin(true);
  };

  const handlePinChange = (event: any) => {
    setPin(event);
  };

  const handleCancel = () => {
    setIsModalOpenCarDetails(false);
    setIsModalOpenVerification(false);
    setIsModalSuccess(false);
    setIsModalFailure(false);
    setIsModalOpenDirectorForm(false);
    setIsModalOpenCarDetails(false);
    setIsModalOpenMerchantOTP(false);
    setIsModalOpenPin(false);
  };
  const handleGoToTerms = () => {
    setIsModalOpenPin(false);
    setIsModalOpenMerchantTerms(true);
  };
  const handleGoBack = () => {
    navigate(-1);
  };

  const handleGoToHistory = () => {
    navigate("/vehicle-finance-home/vehicle-history");
  };

  return (
    <div>
      <MerchantsVehicleDetailsModal
        isModalOpen={isModalOpenCarDetails}
        onSelectChange={handleTenorSelectChange}
        inspectionCheckboxChange={handleinspectionCheckboxChange}
        checkInspection={checkInspection}
        savePayment={handleSavePayment}
        handleCancel={handleCancel}
        onEquityInputChange={handleEquityInputChange}
        loanAmount={LoanAmount}
        equityValue={equityValue}
        isInspection={isInspection}
        loadingApi={loading}
        goBack={handleGoBack}
        repaymentResponseData={repaymentResponseData}
      />
      <MerchantConfirmationVehicleModal
        isModalOpen={isModalOpenMerchantConfirmation}
        openTerms={handleOpenMerchantTerms}
        tenor={tenor}
        equityValue={equity}
        goBackToEquity={handleGoBackToEquity}
      />

      <MerchantsVehicleTermsAndCondition
        isModalOpen={isModalOpenMerchantTerms}
        openSuccess={handleMerchantSuccesss}
        goBackToSummary={handleGoBackToSummary}
        vehicleData={vehicleData}
        goToHistory={handleGoToHistory}
      />

      <MerchantVehicleSuccess
        isModalOpen={isModalOpenMerchantSuccess}
        goToHistory={handleGoToHistory}
      />

      <VehicleFinancePinModal
        isModalOpen={isModalOpenPin}
        pin={pin}
        onChangePinSelectChange={handlePinChange}
        verifyPin={handlePinVerification}
        hideCloseIcon={PaymentCode}
        handleCancel={handleCancel}
        goToTerms={handleGoToTerms}
      />

      <MerchantInspectionSuccessModal
        isModalOpen={isModalOpenInspectionSuccess}
        savePaymentResponse={savePaymentResponse}
        redirect={handleGoToHistory}
      />

      <VehicleLoanProgress isModalOpen={isModalOpenProgress} />
      <VehicleLoadingModal isModalOpen={isModalOpenLoading} />
    </div>
  );
};

export default VehiclePayment;
